import { render, staticRenderFns } from "./ResultsRow.vue?vue&type=template&id=671831d3&"
import script from "./ResultsRow.vue?vue&type=script&lang=js&"
export * from "./ResultsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports